import { render, staticRenderFns } from "./ConsultarTerapiaProgramada.vue?vue&type=template&id=4b69958a"
import script from "./ConsultarTerapiaProgramada.vue?vue&type=script&lang=js"
export * from "./ConsultarTerapiaProgramada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports